import type { Middleware } from '@reduxjs/toolkit'
import { handleLocalStorage } from 'featureSliced/shared/utils/handleLocalStorage'
import i18n from 'featureSliced/shared/utils/localization/i18n'
import { updateMomentLanguage } from 'featureSliced/shared/utils/updateMomentLanguage'
import { CommonSlice } from './reducers/CommonReducer'

/**
 * Persistence and i18n/moment must not run inside reducers — changeLanguage can
 * sync React and trigger useSelector while the reducer is still executing.
 */
export const languageSideEffectsMiddleware: Middleware =
  () => (next) => (action) => {
    const result = next(action)
    if (CommonSlice.actions.setSelectedLanguage.match(action)) {
      const lang = action.payload
      handleLocalStorage({ lang })
      void i18n.changeLanguage(lang)
      updateMomentLanguage(lang)
    }
    return result
  }
